import React from 'react';
import './StaticPageLayout.css';

const StaticPageLayout = ({ title, children }) => {
  return (
    <main className="static-page" role="main">
      <div className="static-page__inner">
        <h2 className="static-page__title">{title}</h2>
        <div className="static-page__content">{children}</div>
      </div>
    </main>
  );
};

export default StaticPageLayout;

